import { Banner } from "components/DesignSystem/Banner/Banner";
import { SmallSparkle } from "components/icons/SmallSparkle";

export const InkleManagedBanner = () => (
  <Banner
    type="info"
    icon={
      <span className="t-text-blue-50 t-shrink-0">
        <SmallSparkle width={20} height={20} />
      </span>
    }
    description="Inkle is already taking care of your books, sit back and relax – We've got it covered!"
    descriptionClassName="t-text-text-100 t-font-semibold"
  />
);
